/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Nav_ClickupInputs */

const en_mk_cmp_nav_clickup = /** @type {(inputs: Mk_Cmp_Nav_ClickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs ClickUp`)
};

const id_mk_cmp_nav_clickup = /** @type {(inputs: Mk_Cmp_Nav_ClickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs ClickUp`)
};

/**
* | output |
* | --- |
* | "vs ClickUp" |
*
* @param {Mk_Cmp_Nav_ClickupInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_nav_clickup = /** @type {((inputs?: Mk_Cmp_Nav_ClickupInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Nav_ClickupInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_nav_clickup(inputs)
	return en_mk_cmp_nav_clickup(inputs)
});